import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { inject, Injectable, InjectionToken } from '@angular/core';

export const DATE_OUTPUT_FORMAT = new InjectionToken<string>(
  'DATE_OUTPUT_FORMAT',
  { factory: () => 'YYYY-MM-DD' }
);

@Injectable()
export class DateStringAdapter extends NgbDateAdapter<string> {
  private outputFormat = inject(DATE_OUTPUT_FORMAT);

  fromModel(value: string | null): NgbDateStruct | null {
    if (!value) return null;

    // Try parsing as ISO date first
    let date = moment(value, moment.ISO_8601, true);

    // If ISO parse failed, try the configured output format
    if (!date.isValid()) {
      date = moment(value, this.outputFormat, true);
    }

    // Fallback to YYYY-MM-DD
    if (!date.isValid()) {
      date = moment(value, 'YYYY-MM-DD', true);
    }

    return date.isValid()
      ? {
          year: date.year(),
          month: date.month() + 1, // Moment uses 0-11
          day: date.date()
        }
      : null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    if (!date) return null;

    // Always return simple date format (YYYY-MM-DD)
    return moment({
      year: date.year,
      month: date.month - 1, // NgbDateStruct uses 1-12
      day: date.day
    }).format(this.outputFormat);
  }
}
